import React, { forwardRef, useImperativeHandle, useState } from 'react';
import { Button } from '../bootstrap/index.jsx';

const StatusBarComponent = forwardRef(({
  initialVisible = false, 
  onSave, 
  onDiscard
}, ref) => {
  const [visible, setVisible] = useState(initialVisible);

  useImperativeHandle(ref, () => {
    return {
      setVisible: (visible) => {
        setVisible(visible);
      },
      isVisible: () => {
        return visible;
      },
    };
  }, []);

  if (visible) {
    return (
      <div style={{margin: '0.5rem', display: 'flex', gap: '1rem'}} className='datagrid-statusbar-component'>
        <Button size="sm" type='default' onClick={onDiscard} >{I18n.t('discard')}</Button>
        <Button size="sm" onClick={onSave} >{I18n.t('save')}</Button>
      </div>
    );
  }

  return null;
});

export default StatusBarComponent;